import { render, staticRenderFns } from "./TemplatePartsButtons.vue?vue&type=template&id=70c3c7f0&scoped=true&"
import script from "./TemplatePartsButtons.vue?vue&type=script&lang=js&"
export * from "./TemplatePartsButtons.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePartsButtons.vue?vue&type=style&index=0&id=70c3c7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3c7f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c3c7f0')) {
      api.createRecord('70c3c7f0', component.options)
    } else {
      api.reload('70c3c7f0', component.options)
    }
    module.hot.accept("./TemplatePartsButtons.vue?vue&type=template&id=70c3c7f0&scoped=true&", function () {
      api.rerender('70c3c7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/TemplatePartsButtons.vue"
export default component.exports